// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UpdateDigitalAssetRequestModel from '../../model/update-digital-asset-request-model';
import UpdateDigitalAssetRequestDTO from '../dto/update-digital-asset-request-dto';
import dtoSchema from '../schemas/update-digital-asset-request-schema';

export default abstract class UpdateDigitalAssetRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UpdateDigitalAssetRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.fileName = data.fileName;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  fileName?: string;

  static toModel(dto: DeepPartial<UpdateDigitalAssetRequestDTO>): UpdateDigitalAssetRequestModel;
  static toModel(dto: DeepPartial<UpdateDigitalAssetRequestDTO> | undefined | null): UpdateDigitalAssetRequestModel | undefined;
  static toModel(dto: DeepPartial<UpdateDigitalAssetRequestDTO> | undefined | null): UpdateDigitalAssetRequestModel | undefined {
    return dto ? new UpdateDigitalAssetRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UpdateDigitalAssetRequestModel> | UpdateDigitalAssetRequestModel): UpdateDigitalAssetRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      fileName: unwrapped.fileName,
    } as UpdateDigitalAssetRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UpdateDigitalAssetRequestModel, can not map to UpdateDigitalAssetRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
